import { Injectable, inject } from '@angular/core';
import { isBrowserContext, isNil, isNotNil, Nillable } from '@web/utils';
import { Observable } from 'rxjs';
import { Environment, ENVIRONMENT } from '@web/config';

// TODO Przenieść ten serwis do nowego modułu w shared/module/facebook

declare let window: {
  fbAsyncInit: () => void;
};

declare let FB: {
  init: (options: {
    appId: string;
    cookie: boolean;
    xfbml: boolean;
    version: 'v20.0';
  }) => void;
  // https://developers.facebook.com/docs/facebook-login/web/
  login: (
    callback: (response: {
      authResponse?: {
        accessToken: string;
        expiresIn: number;
        userID: string;
      };
      status: 'connected' | 'not_authorized' | 'unknown';
    }) => Promise<void>,
  ) => void;
};

@Injectable({
  providedIn: 'root',
})
export class FacebookService {
  private readonly environment = inject<Environment>(ENVIRONMENT);

  private readonly isBrowserContext = isBrowserContext();

  public constructor() {
    if (!this.isBrowserContext) {
      return;
    }

    this.loadSDKScript();
    this.initializeSDK();
  }

  public login(): Observable<Nillable<string>> {
    return new Observable<Nillable<string>>((subscriber) => {
      FB.login(async (response) => {
        const { authResponse } = response;
        console.log(response);

        subscriber.next(authResponse?.accessToken);
        subscriber.complete();
      });
    });
  }

  private loadSDKScript(): void {
    (function loadFacebookSDK(
      document: Document,
      scriptTag: string,
      sdkId: string,
    ): void {
      const firstScript: Element = document.getElementsByTagName(scriptTag)[0];
      const element = document.getElementById(sdkId);

      if (isNotNil(element)) {
        return;
      }

      const scriptElement = document.createElement(
        scriptTag,
      ) as HTMLScriptElement;
      scriptElement.id = sdkId;
      scriptElement.src = 'https://connect.facebook.net/en_US/sdk.js';

      const parentNode = firstScript.parentNode;

      if (isNil(parentNode)) {
        return;
      }

      parentNode.insertBefore(scriptElement, firstScript);
    })(document, 'script', 'facebook-jssdk');
  }

  private initializeSDK(): void {
    window.fbAsyncInit = () => {
      FB.init({
        appId: this.environment.FacebookAppId,
        cookie: true,
        xfbml: true,
        version: 'v20.0',
      });
    };
  }
}
